import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const NotificationsTypeIcon = ({type}) => {
    const getIcon = (key) => {
        const icons = {
            "t": <FontAwesomeIcon icon="list" size={"1x"} className="d-block m-auto" style={{color: '#666',}}/>,
            "r": <FontAwesomeIcon icon="file" size={"1x"} className="d-block m-auto" style={{color: '#666',}}/>,
            "s": <FontAwesomeIcon icon="paper-plane" size={"1x"} className="d-block m-auto" style={{color: '#22deea',}}/>,
            "i": <FontAwesomeIcon icon="info" size={"1x"} className="d-block m-auto" style={{color: '#ffc107',}}/>,
            "e": <FontAwesomeIcon icon="exclamation" size={"1x"} className="d-block m-auto" style={{color: '#dc3545',}}/>,
            "p": <FontAwesomeIcon icon="gear" size={"1x"} className="text-primary d-block m-auto"/>,
        };
        return icons[key];
    };

    return (getIcon(type))
}
export default NotificationsTypeIcon